export default class ConnectionBase {
    constructor(user = 'user', pass = 'password', uriBase = '', apiPoint = ''){
        this.connection = {
        connected: false,

        userName: user,
        password: pass,
        apiEntryPoint: apiPoint,

        uri: uriBase,
        token: '',
        error: 0,
        errorMessage: '',
        };
        this.headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Connection': 'keep-alive',
            'Authorization': 'Bearer ' + this.connection.token,
        };
        this.body = '';
        this.internalError = 0;
    }
    // getters block
    get connected(){
        return this.connection.connected;
    }

    get userName(){
        return this.connection.userName;
    }
    get password(){
        return this.connection.password;
    }
    get apiEntryPoint(){
        return this.connection.apiEntryPoint;
    }
    get token(){
        return this.connection.token;
    }
    get entryPoint(){
        return this.uri + '/' + this.apiEntryPoint + '/';
    }
    get error(){
        return this.connection.error;
    }
    get errorMessage(){
        return this.connection.errorMessage;
    }

    get uri(){
        return this.connection.uri;
    }    
    get isAdmin(){
        return false;
    }
    set requestBody(req){
        this.body = req;
    }
    set uriBase(uri){
        this.connection.uri = uri;
    }
    set userName(name){
        this.connection.userName = name;
    }
    set password(p){
        this.connection.password = p;
    }
    set apiEntryPoint(point){
        this.connection.apiEntryPoint = point;
    }
    set token(t){
        this.connection.token = t;
    }
    set error(e){
        this.connection.error = e;
    }
    set errorMessage(mes){
        this.connection.errorMessage = mes;
    }

    async logout(){
        let conStr = this.entryPoint + 'signout';
        let result = await this.sendRequest('POST', conStr, null);
        if (result.error == 0) {
            this.connection.connected = false;
            this.connection.token = '';
            this.headers['Authorization'] = '';           
        }
        return result;
    }

    async sendRequest(requestMethod, uri, body){
        try {
            const response = await fetch(
              uri,
              {
                method: requestMethod,
                headers: this.headers,
                body: body,

              });
            const json = await response.json();
            if (json.error == 1){
                this.connection.connected = false;
                this.connection.token = '';
                this.headers['Authorization'] = '';                     
            }
            return json;
        } catch (err) {
            const result = {
                error: 0,
                message: '',
                data: null,
            };
            //console.error(err);
            if (err.name === 'AbortError'){
                result.error = -1;
                result.message = 'Request was aborted.'
            } else {
                result.error = -2;
                result.message = 'При выполнении запроса возникла ошибка';
            }
            return result;
        }
    }

    async authorize(uri) {
        let conStr = this.entryPoint + uri;
        this.connection.connected = false;
        let body = JSON.stringify({
            userPhone: this.userName,
            password: this.password,
        });

        let result = await this.sendRequest('POST', conStr, body);
        if (result.error === 0){
            this.connection.token = result.data.token;
            this.headers['Authorization'] = 'Bearer ' + this.connection.token;
            this.connection.connected = true;
        } else {
            this.connection.connected = false;
        }
        return result;
    }

    isConnected() {
        return this.connection.connected;
    }
}